<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="举报人" prop="userName" >
        <a-input readOnly v-model="form.userName" placeholder="请输入用户ID｛user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="举报人手机号" prop="reportMobile" >
        <a-input readOnly v-model="form.reportMobile" placeholder="请输入举报人手机号" />
      </a-form-model-item>
      <a-form-model-item label="被举报人" prop="reportUserName" >
        <a-input readOnly v-model="form.reportUserName" placeholder="请输入举报用户ID｛user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="被举报人手机号" prop="reportUserMobile" >
        <a-input readOnly v-model="form.reportUserMobile" placeholder="请输入被举报人手机号" />
      </a-form-model-item>
      <a-form-model-item label="链接地址" prop="url" v-if="form.url">
        <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="form.type == 1"
         v-for="img in form.url.split(',')"    :src="img" preview="头像"/>
        <video v-else   style="width: 180px;height: 120px"
               class="avatar video-avatar"
               controls="controls"  :src="form.url"/>
      </a-form-model-item>
      <a-form-model-item label="举报原因" prop="reportReason" >
        <a-input readOnly v-model="form.reportReason" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
     <a-form-model-item label="详细说明" prop="detailDesc" >
       <a-input readOnly v-model="form.detailDesc" placeholder="暂无" type="textarea" allow-clear />
     </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-radio-group :readonly="isInfo == 2" v-model="form.status">
          <!-- <a-radio :value="0">待审核</a-radio> -->
          <a-radio :value="1">审核通过</a-radio>
          <a-radio :value="2">驳回</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="驳回原因" prop="rejectReason" v-if="form.status == 2">
        <a-input  :readonly="isInfo == 2" v-model="form.rejectReason" placeholder="暂无" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="formType!=3" type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getReport, addReport, updateReport } from '@/api/user/report'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isInfo:1,
      // 表单参数
      form: {
        id: null,
        userId: null,
        userName:null,
        reportUserName:null,
        reportUserId: null,
        type: null,
        url: null,
        reportMobile:"",
        reportUserMobile:"",
        reportReason: null,
        detailDesc: null,
        status: null,
        rejectReason: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [
          { required: true, message: '状态不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.reset()
      this.open = false
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        userName:null,
        reportUserName:null,
        reportUserId: null,
        type: null,
        url: null,
        reportReason: null,
        detailDesc: null,
        status: null,
        rejectReason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.open = true
      this.reset()
      this.formType = 1

      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.open = true
        this.formTitle = '审核'
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReport({"id":id}).then(response => {
        this.form = response.data
        this.form.status = null
      })
    },

    handleInfo (row, ids) {
      this.open = true
        this.formTitle = '详情'
      this.reset()
      this.formType = 3
      const id = row ? row.id : ids
      getReport({"id":id}).then(response => {
        this.form = response.data
        this.isInfo = 2
      })
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateReport(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addReport(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
